'use client';
import type { PopupModalProps } from 'app/_components/PopupModal';
import { useEventStore } from 'app/_event';

export const usePopupLists = (): PopupModalProps['items'] => {
  const isPeakDays = useEventStore((s) => s.activeEvent === 'xmas' && s.meta.isPeakDays);
  const isAfterPeakStart = useEventStore((s) => s.activeEvent === 'xmas' && s.meta.isPeak);

  return [
    {
      src: '/images/popupImages/main_popup_01.png',
      title: '단 3일간! 적립금 인상 이벤트',
      content: '[인스타 팔로워] 25→30원 / 자동적립 15→18원\n[인스타 좋아요] 5→6원',
      link: 'https://viewup.co.kr/viewing',
      condition: () => isPeakDays,
    },
    {
      src: '/images/popupImages/main_popup_02.png',
      title: '매일 2배 포인트! 출석 체크 이벤트',
      content:
        '12월 한달간 매일 스탬프 찍고 포인트 적립,\n22일~25일 더블 포인트 찬스도 놓치지 마세요!',
      link: 'https://viewup.co.kr/stamp',
      condition: () => isAfterPeakStart,
    },
    {
      src: '/images/popupImages/main_popup_04.png',
      title: '환급, 기다림을 줄였어요!',
      content: '30일에서 20일로 단축된 환급으로\n더 빠르게 적립금을 돌려받으세요.',
      link: 'https://viewup.co.kr/notice/01993bb2-e7dc-4bdb-9366-25bd9dba7b37',
      condition: () => true,
    },
  ];
};
